export const AdminAccessControlController = {
    index(): void {},
    toggleIp(): void {},
    toggleCountry(): void {},
    storeIp(): void {},
    destroyIp(): void {},
    storeCountry(): void {},
    destroyCountry(): void {},
};
